function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 100,
  height: 100
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M43 15V57M43 15V57",
  stroke: "black",
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M84.9998 57L43.0001 57.16M84.9998 57L43.0001 57.16",
  stroke: "black",
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 15,
  r: 4.5,
  fill: "#E02525",
  stroke: "black"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 43,
  cy: 57,
  r: 4.5,
  fill: "#E02525",
  stroke: "black"
});

var _ref7 = /*#__PURE__*/React.createElement("circle", {
  cx: 85,
  cy: 57,
  r: 4.5,
  fill: "#E02525",
  stroke: "black"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.8784 59L21 80M40.8784 59L21 80",
  stroke: "black",
  strokeLinecap: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 80,
  r: 4.5,
  fill: "#E02525",
  stroke: "black"
});

function SvgAx3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAx3);
export default __webpack_public_path__ + "static/media/ax-3.9f969563.svg";
export { ForwardRef as ReactComponent };